module.exports = __webpack_public_path__ + "static/media/step1.b6fc9ccc.png";